import axios from "../helpers/axios";

export const officeTaskTypes = {
    LIST_REQUEST: "OFFICE_TASK_LIST_REQUEST",
    LIST_SUCCESS: "OFFICE_TASK_LIST_SUCCESS",
    LIST_FAILURE: "OFFICE_TASK_LIST_FAILURE",
    MUTATION_REQUEST: "OFFICE_TASK_MUTATION_REQUEST",
    MUTATION_SUCCESS: "OFFICE_TASK_MUTATION_SUCCESS",
    MUTATION_FAILURE: "OFFICE_TASK_MUTATION_FAILURE",
    SELECT: "OFFICE_TASK_SELECT",
    CLEAR_ERROR: "OFFICE_TASK_CLEAR_ERROR",
};

const getError = (error, fallback = "Ошибка задания") =>
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    fallback;

const buildQuery = (params = {}) => {
    const search = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "") return;
        search.set(key, String(value));
    });

    return search.toString() ? `?${search.toString()}` : "";
};

export const getOfficeTasks = ({ officeId, status = "", priority = "", q = "" } = {}) => async (dispatch) => {
    dispatch({ type: officeTaskTypes.LIST_REQUEST });

    try {
        const response = await axios.get(
            `/office/${officeId}/tasks${buildQuery({ status, priority, q })}`
        );

        dispatch({
            type: officeTaskTypes.LIST_SUCCESS,
            payload: {
                tasks: response.data?.tasks || [],
                meta: response.data?.meta || {},
            },
        });

        return response.data;
    } catch (error) {
        dispatch({
            type: officeTaskTypes.LIST_FAILURE,
            payload: { error: getError(error, "Не удалось загрузить задания") },
        });
        throw error;
    }
};

const runMutation = ({ method, url, data, fallback }) => async (dispatch) => {
    dispatch({ type: officeTaskTypes.MUTATION_REQUEST });

    try {
        const response = await axios({ method, url, data });

        dispatch({
            type: officeTaskTypes.MUTATION_SUCCESS,
            payload: {
                task: response.data?.task || null,
                message: response.data?.message || "",
            },
        });

        return response.data;
    } catch (error) {
        dispatch({
            type: officeTaskTypes.MUTATION_FAILURE,
            payload: { error: getError(error, fallback) },
        });
        throw error;
    }
};

export const createOfficeTask = (officeId, payload) => runMutation({
    method: "post",
    url: `/office/${officeId}/tasks`,
    data: payload,
    fallback: "Не удалось создать задание",
});

export const updateOfficeTask = (officeId, taskId, payload) => runMutation({
    method: "patch",
    url: `/office/${officeId}/tasks/${taskId}`,
    data: payload,
    fallback: "Не удалось изменить задание",
});

export const runOfficeTaskAction = (officeId, taskId, action, payload = {}) => runMutation({
    method: "post",
    url: `/office/${officeId}/tasks/${taskId}/action`,
    data: { action, ...payload },
    fallback: "Не удалось изменить статус задания",
});

export const toggleOfficeTaskChecklist = (officeId, taskId, checklistItemId, completed) => runMutation({
    method: "patch",
    url: `/office/${officeId}/tasks/${taskId}/checklist/${checklistItemId}`,
    data: { completed },
    fallback: "Не удалось изменить чек-лист",
});

export const addOfficeTaskComment = (officeId, taskId, text) => runMutation({
    method: "post",
    url: `/office/${officeId}/tasks/${taskId}/comment`,
    data: { text },
    fallback: "Не удалось добавить комментарий",
});


export const uploadOfficeTaskPhoto = (officeId, taskId, file, kind = "report") => async (dispatch) => {
    dispatch({ type: officeTaskTypes.MUTATION_REQUEST });

    try {
        const data = new FormData();
        data.append("photo", file);
        data.append("kind", kind === "reference" ? "reference" : "report");

        const response = await axios.post(
            `/office/${officeId}/tasks/${taskId}/photos`,
            data
        );

        dispatch({
            type: officeTaskTypes.MUTATION_SUCCESS,
            payload: {
                task: response.data?.task || null,
                message: response.data?.message || "",
            },
        });

        return response.data;
    } catch (error) {
        dispatch({
            type: officeTaskTypes.MUTATION_FAILURE,
            payload: {
                error: getError(error, "Не удалось загрузить фото"),
            },
        });
        throw error;
    }
};

export const deleteOfficeTaskPhoto = (officeId, taskId, photoId) => runMutation({
    method: "delete",
    url: `/office/${officeId}/tasks/${taskId}/photos/${photoId}`,
    fallback: "Не удалось удалить фото",
});

export const selectOfficeTask = (task) => ({
    type: officeTaskTypes.SELECT,
    payload: task || null,
});

export const clearOfficeTaskError = () => ({
    type: officeTaskTypes.CLEAR_ERROR,
});
